window.TWILIO_ACTIVITY_AVAILABLE = 'Available';
window.TWILIO_ACTIVITY_UNAVAILABLE = 'Unavailable';
window.TWILIO_ACTIVITY_OFFLINE = 'Offline';
window.TWILIO_ACTIVITY_BREAK = 'Break';

class TourlaneFlex {
  static #events = {}
  static #isCalling = false

  // listen to events from the Tourlane Customization Twilio plugin
  // https://github.com/tourlane/twilio_tourlane_customization_plugin
  static start() {
    const onFlexPluginPostMessage = (event) => {
      var data = {}
      try {
        data = JSON.parse(event.data)
      } catch { }
      var actionMatch = data.action ? data.action.match(/TwilioTourlaneCustomizaton: (.+)/) : null
      if (!actionMatch) {
        return
      }

      this.getListeners(actionMatch[1]).forEach(
        listener => listener(data.payload)
      );
    }
    window.addEventListener('message', onFlexPluginPostMessage, false);
  }

  static addEventListener(event, listener) {
    if (this.#events[event]) {
      this.#events[event].push(listener)
    } else {
      this.#events[event] = [listener]
    }
  }

  static getListeners(event) {
    return this.#events[event] || []
  }

  static setIsCalling(isCalling) {
    this.#isCalling = isCalling;
  }

  static isCalling() {
    return this.#isCalling;
  }

  static setActivityStatus(activityStatus) {
    const message = {
      action: 'changeActivityStatus',
      activityStatus: activityStatus
    };

    this.postMessage(message);
  }

  static endCall() {
    const message = {
      action: 'endCall'
    };

    this.postMessage(message);
  }

  static postMessage(message) {
    TourlaneIframeCommunication.postMessage(message);
  }
}

// We are in an active call and want to open a new tab where the agent can perform some action.
// When the tab is closed the agent returns to this original tab and the call is ended.
function openUrlInNewTabWhileTwilioCallIsActive(url) {
  TourlaneFlex.setActivityStatus(TWILIO_ACTIVITY_UNAVAILABLE);
  // Open a new tab and focus it
  const newTab = window.open(url, '_blank')
  if (newTab) {
    newTab.focus()
    // Check if the tab is closed every second and set the activity to available if it is + end the call.
    // Note: Works more reliable than the `onclose` or `onbeforeunload` events.
    const timer = setInterval(() => {
      if (newTab.closed) {
        clearInterval(timer)
        TourlaneFlex.setActivityStatus(TWILIO_ACTIVITY_AVAILABLE);
        TourlaneFlex.endCall();
      }
    }, 1000);
  } else {
    alert('Unable to open new tab. Please allow popups for this site.')
  }
}

(function() {
  function handleReservationCreated(payload) {
    if (payload.taskAttributes.direction !== 'inbound') {
      return
    }
    TourlaneSuite.showFlexIframe();
    displayCallNotification(payload.taskAttributes.from);
  }

  // Incoming call: The SA answers the call.
  function handleReservationAccepted(payload) {
    if (payload.taskAttributes.direction !== 'inbound') {
      return
    }
    TourlaneFlex.setIsCalling(true);
    const callSid = payload.taskAttributes.conference?.participants?.worker || payload.taskAttributes.call_sid
    TourlaneSuite.showFlexIframe();
    fetchLeadDetailPage(callSid);
  }

  // The moment the SA answers the call the reservation.accepted event is fired. Twilio will
  // send the event to our /webhook/twilio/workspace_event endpoint.
  // Use the twilio_call_sid on the task attributes to fetch the detail page for the lead.
  // Attempt up to 10 times and wait a second after each attempt. We attempt several times
  // because we actually have to wait for Twilio to send the reservation.accepted event to 
  // the endpoint mentioned above. When we receive the event we find or create the lead that corresponds
  // to the number that is calling us. See Twilio::WorkspaceEventHandler.
  // The call object and lead are usually created on the second attempt already.
  function fetchLeadDetailPage(callSid, attempts = 0) {
    if (attempts >= 10) {
      return
    }

    $.getJSON(`/qualification/twilio/incoming_call/${callSid}`, (data) => {
      if (data.success) {
        openUrlInNewTabWhileTwilioCallIsActive(data.url);
      } else {
        setTimeout(() => {
          fetchLeadDetailPage(callSid, attempts + 1);
        }, 1000)
      }
    });
  }

  function hangupButton() {
    return $('#button-hangup-external');
  }

  function callNowLink() {
    return $('#call-now-link');
  }

  function endCall(e) {
    e.preventDefault();
    hangupButton().hide();
    callNowLink().show();
    TourlaneFlex.endCall();
  }

  window.addEventListener('DOMContentLoaded', () => {
    TourlaneFlex.start();
    // Listeners are for inbound calls only.
    TourlaneFlex.addEventListener('reservationAccepted', handleReservationAccepted);
    TourlaneFlex.addEventListener('reservationCreated', handleReservationCreated);
    hangupButton().on('click', endCall);
  });
})();

export { TourlaneFlex, openUrlInNewTabWhileTwilioCallIsActive };
